import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ScheduleDetailPage = lazy(
  () => import('~/features/catalog-enrichment/pages/schedule-detail-page'),
);

/** One schedule's own page (design guide part 3 §4.5): it used to be a column beside the list. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/schedules/$scheduleId',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { scheduleId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ScheduleDetailPage scheduleId={scheduleId} />
    </Suspense>
  );
}
